import { render, staticRenderFns } from "./brokerage-tabar..vue?vue&type=template&id=79c08c3a&scoped=true&"
import script from "./brokerage-tabar..vue?vue&type=script&lang=js&"
export * from "./brokerage-tabar..vue?vue&type=script&lang=js&"
import style0 from "./brokerage-tabar..vue?vue&type=style&index=0&id=79c08c3a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c08c3a",
  null
  
)

export default component.exports